import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { GlobalsService } from '../../../../core/services/globals.service';
import {
  PostRequestBase,
  ResponseBase,
  ScreenModel,
} from '../../../../core/models/common';
import { ApiService } from '../../../../core/services/api-mock.service';

export interface ChangePasswordRequestData extends PostRequestBase {
  NewPassword: string;
}

export interface ChangePasswordResponseData extends ResponseBase {}

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  @Output() handleChangePasswordSubmit = new EventEmitter<string>();
  forgotPasswordForm: FormGroup = this.formBuilder.group({
    caseID: [
      '',
      [Validators.required, Validators.maxLength(64)],
    ],
    emailID: [
      '',
      [Validators.required,  Validators.email],
    ],
  });

  constructor(
    private formBuilder: FormBuilder,
    public globals: GlobalsService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    console.log('[ModalBodyComponent] Modal OnInit');
  }

  handleCloseModal(){
    this.activeModal.close();
  }

  async onForgotPassword() {
    
    let caseID = (this.forgotPasswordForm.get('caseID') as FormControl).value;
    let emailID = (this.forgotPasswordForm.get('emailID') as FormControl).value
    let forgotPassObj = {
      caseID:caseID ,
      emailID:emailID
    }

    this.handleChangePasswordSubmit.emit(JSON.stringify(forgotPassObj));
  }
}
